export const allYouCanEatTag = 'all_you_can_eat';
export const bundleCategory = 'bundle';
